import React, { useState, useEffect } from "react";
import axios from "axios";
import { Radio, Table, Input, DatePicker, Modal, Card, Row, Col, Space, Image, Checkbox, Button, message } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ExclamationCircleOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
import AdminEnvironmentModal from "./components/AdminEnvironmentModal";
const { RangePicker } = DatePicker;

const ClassRoomList = () => {
    const { confirm } = Modal;
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [data, setData] = useState([]);
    const [datas, setDatas] = useState([])
    const [check, setCheck] = useState()
    const [messageApi, contextHolder] = message.useMessage();
    var checkvalue = []
    var Remove = []
    const columns = [
        {
            title: '照片',
            key: 'surrounding_id',
            render: (text, record, index) => (
                <>
                    <Row gutter={8}>
                        {/* <Carousel> */}
                        {record['file_url'] ? record['file_url'].map((tmp, index) => {
                            return (
                                <>
                                    <Col >
                                        <img width="80px" height="100%" alt="example" src={tmp} />
                                    </Col >
                                </>
                            )
                        }) :
                            <>
                                <Col >
                                    <img width="80px" height="100%" src="data:image/png;base64,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" />
                                </Col >

                            </>}
                        {/* </Carousel> */}
                        {/* <img src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png" width={'100 %'}></img> */}
                    </Row >
                </>
            )
        },
        {
            title: '設備',
            key: '',
            render: (text, record, index) => (
                <>
                </>
            )
        },
        {
            title: '資訊',
            key: 'surrounding_id',
            render: (text, record, index) => (
                <>
                    <Col >
                        <p style={{ fontSize: '24px', fontWeight: 400, }}>{record.name}</p>
                        <p style={{ fontSize: '18px', fontWeight: 400, }}>{record.name_serial}</p>
                        <p style={{ fontSize: '18px', fontWeight: 400, }}>容納人數:{record.capacity}人</p>
                        <p style={{ fontSize: '18px', fontWeight: 400, }}>內文：{record.note}</p>
                    </Col>
                </>
            )
        },
        {
            title: '操作',
            key: 'control',
            render: (text, record, index) => (
                <>
                    <Button style={{ backgroundColor: 'rgba(255, 255, 232, 1)', display: "inline-flex", alignItems: "center" }} onClick={e => { setTitle('修改教室'); setColor('f09a45'); setEdit(true); setOpen(true); }} icon={<EditOutlined />}>編輯</Button>
                </>
            )
        },
    ];
    const get_datas = () => {
        axios
            .get(`/cramSchool/api/surrounding`, {
                params: {
                    // cur_page: 1,
                    // size: 10
                }
            })
            .then((response) => {
                setDatas(response.data)
                get_picture(response.data)
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['surrounding_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const handleOnDelete = () => {
        const deleterow = [];
        selectedRowKeys && selectedRowKeys.map((value) => {
            deleterow.push({ 'lesson_category_id': value });
        })
        axios
            .delete(`/cramSchool/api/surrounding`, {
                data: deleterow
            })
            .then((response) => {
                // console.log(response)
                if (response.data.status == 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_datas();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_datas();
                }
            })
    }
    const handleEdit = () => {
        setOpen(false);
        axios
            .patch(`/cramSchool/api/surrounding`, [{ ...editcard }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_datas();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_datas();
                }
            })
        // console.log(editcard);
    }
    const handleSubmit = () => {
        axios
            .post(`/cramSchool/api/surrounding`, [{ ...editcard }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '新增失敗',
                    });
                    get_datas();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    get_datas();
                }
            })
        // console.log(editcard);
    }
    useEffect(() => {
        get_datas()
    }, []);
    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selectedRowKeys.length !== 0) {
                setSelectedRowKeys([]);
            }
        },
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);

        },

    };
    const showMessageAll = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete();
            },
            centered: true
        });
    };
    return (
        <>
            {contextHolder}
            <AdminEnvironmentModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                setData={setData}
                data={data}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleSubmit={handleSubmit}
                handleEdit={handleEdit}
            />
            <Row gutter={[8, 16]} style={{ padding: '20px' }}>
                <Col span={24}>
                    <Row gutter={8}>
                        <Space wrap>
                            {/* <label style={{ fontSize: '24px', color: '#505050' }}>搜尋：</label> */}
                            <Input placeholder='請輸入ID/課程名稱' />
                            <Button style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} block>搜尋</Button>
                            <Button style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} onClick={e => { setTitle('新增教室'); setColor('d65b77'); setEditCard({}); setEdit(false); setOpen(true) }} icon={<PlusOutlined />}>新增環境</Button >
                            <Button style={{ backgroundColor: 'rgba(255, 242, 237, 1)' }} onClick={e => showMessageAll()}>
                                <Row>
                                    <Col span={6}>
                                        <img width="80%" src='/cram_school/error.png'></img>
                                    </Col>
                                    <Col span={18}>
                                        <span>批次刪除</span>
                                    </Col>
                                </Row>
                            </Button>
                        </Space>
                    </Row>
                </Col>
                <Col span={24}>
                    <Table
                        style={{ cursor: 'pointer' }}
                        dataSource={datas}
                        columns={columns}
                        tableLayout={'fixed'}
                        scroll={{ x: 'max-content' }}
                        rowSelection={{
                            type: 'checkbox',
                            ...rowSelection,
                        }}
                        rowKey={record => record['surrounding_id']}
                    />
                </Col>
            </Row>

        </>
    );
};

export default ClassRoomList;